








































































import { Component, Prop, Vue } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import { WidgetThemesDictionary } from '@/models/Widget/themes';
import { IWidgetSettingsFormData } from '@/models/Widget/settings';

import ButtonTabs from '@/components/molecules/ButtonTabs/ButtonTabs.vue';
import ButtonTabsV2 from '@/componentsV2/molecules/ButtonTabs/ButtonTabs.vue';
import MockupWidgetPreview from '@/componentsV2/organisms/MockupWidgetPreview/MockupWidgetPreview.vue';
import { configWidgetFormDataFactory } from '@/views/Onboarding/helpers';
import flagKeys from '@/constants/flagKeys';
import { isExternalOauthSessionOnline } from '@/router/router-utils';

@Component({
  components: {
    ButtonTabs,
    ButtonTabsV2,
    MockupWidgetPreview
  }
})
export default class DevicePreviewBox extends Vue {
  @Prop({ required: true, default: configWidgetFormDataFactory() })
  formData!: IWidgetSettingsFormData;
  @Prop({ default: 'desktop' }) device?: string;
  @Prop({ default: false }) isInternalPage?: boolean;

  get tPrefix() {
    return 'common.components.devicePreviewBox';
  }

  get devices(): string[] {
    return [
      String(this.$t(`${this.tPrefix}.desktopLabel`)),
      String(this.$t(`${this.tPrefix}.mobileLabel`))
    ];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isNewOnlineSignup() {
    return isExternalOauthSessionOnline();
  }

  get themeSettings() {
    return WidgetThemesDictionary[this.formData.widgetStyle.color];
  }

  get placementDirection() {
    const widgetSettings = this.formData;

    if (!widgetSettings) return '';

    const { placement } = widgetSettings;
    const { positioning } = placement;

    return positioning;
  }

  get themeTextColor() {
    return this.themeSettings.primaryGradientTextColor || '#FFF';
  }

  handleChangeTab(tab: string) {
    eventBus.$emit('widgetConfigFormSetTab', tab);
  }

  handleClickDevice(device: string) {
    eventBus.$emit('widgetConfigFormSetTab', device);
  }
}
